<div class="sidenav">
    <div class="logo-box"><img height="50px" src="assets/img/logo.png" /></div>
    <div class="login-main-text">
        <h2>BeAlign</h2>
        <p>Acceso para ortodoncistas</p>
    </div>
</div>
<div class="main">
    <div class="col-md-6 col-sm-12">
        <div class="login-form">
            <form #f=ngForm name="form" (ngSubmit)="f.form.valid && submitLogin()">
                <div class="form-group">
                    <label>Correo Electrónico</label>
                    <input type="email" class="form-control" placeholder="Correo Electrónico"
                        [(ngModel)]="loginData.email" name="email" email
                        [ngClass]="{'is-invalid':  f.submitted && email.invalid}" #email="ngModel" required />
                    <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                        <div *ngIf="email.errors.required">El e-mail es requerido</div>
                        <div *ngIf="email.errors.email">Tiene que ingresar un correo válido</div>
                    </div>
                </div>
                <div class="form-group">
                    <label>Contraseña</label>
                    <input type="password" class="form-control" placeholder="Contraseña"
                        [(ngModel)]="loginData.password" name="password"
                        [ngClass]="{'is-invalid':  f.submitted && password.invalid}" #password="ngModel" required />
                    <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                        <div *ngIf="password.errors.required">La contraseña es requerida</div>
                    </div>
                </div>
                <button type="submit" class="btn btn-primary" >Iniciar Sesión</button>
                <button type="button" (click)="backClicked()" class="btn btn-link">Cancelar</button>
            </form>
        </div>
    </div>
</div>